import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Box, makeStyles, Theme, Typography } from '@material-ui/core'
import { AddOutlined } from '@material-ui/icons'
import React, { FC, useCallback } from 'react'
import colors from '../../../../listingColors'
import { PPL_ACTIONS, usePPLContext } from '../PPLProvider'

const { boxBackground, boxBorder, buttonSecondary, defaultLight } = colors

const useStyles = makeStyles((theme: Theme) => ({
    modeSelectorContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: boxBackground,
        border: `1px solid ${boxBorder}`,
        borderRadius: theme.spacing(1),
        height: theme.spacing(15),
        paddingRight: theme.spacing(3),
        paddingLeft: theme.spacing(1),
        width: '100%',

        maxWidth: pxToRem(705),
    },
    modeButtons: {
        marginLeft: pxToRem(21),
    },
    modeButtonLabel: {
        fontWeight: 'normal',
        fontSize: pxToRem(13),
        padding: theme.spacing(0.5),
    },
    modeAddIcon: {
        marginRight: theme.spacing(1),
        height: theme.spacing(2),
        width: theme.spacing(2),
    },
}))

const NonMSModeSelector: FC = () => {
    const classes = useStyles()

    const { dispatch } = usePPLContext()

    const handleAddBasic = useCallback(() => {
        dispatch?.({
            type: PPL_ACTIONS.batchNonMSActions,
            payload: [
                { type: PPL_ACTIONS.setEditPropertyID, payload: '' },
                { type: PPL_ACTIONS.createNewProperty },
                { type: PPL_ACTIONS.setMode, payload: 'basic' },
            ],
        })
    }, [dispatch])

    const handleAddInLine = useCallback(() => {
        dispatch?.({
            type: PPL_ACTIONS.batchNonMSActions,
            payload: [
                { type: PPL_ACTIONS.setEditPropertyID, payload: '' },
                { type: PPL_ACTIONS.createNewProperty },
                { type: PPL_ACTIONS.setMode, payload: 'inline' },
            ],
        })
    }, [dispatch])

    return (
        <Box className={classes.modeSelectorContainer}>
            <Box className={classes.modeButtons}>
                <RoundButton
                    hasShadow={false}
                    borderColor={buttonSecondary}
                    color={defaultLight}
                    backgroundColor={buttonSecondary}
                    data-testid="moDialogManufacturerAddBasicButton"
                    onClick={handleAddBasic}
                >
                    <Typography
                        component="span"
                        className={classes.modeButtonLabel}
                    >
                        <AddOutlined className={classes.modeAddIcon} />
                        Add Basic
                    </Typography>
                </RoundButton>
            </Box>

            <Box className={classes.modeButtons}>
                <RoundButton
                    hasShadow={false}
                    borderColor={buttonSecondary}
                    color={defaultLight}
                    backgroundColor={buttonSecondary}
                    data-testid="moDialogManufacturerAddInlineButton"
                    onClick={handleAddInLine}
                >
                    <Typography
                        component="span"
                        className={classes.modeButtonLabel}
                    >
                        <AddOutlined className={classes.modeAddIcon} />
                        Add In-Line
                    </Typography>
                </RoundButton>
            </Box>
        </Box>
    )
}

export default NonMSModeSelector
